import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "purchase"
  static values = { userId: String }

  buy(event) {
    if (this.inFlight) return
    this.lock(event.currentTarget)

    const productId = event.currentTarget.dataset.purchaseProductIdValue
    this.send("purchase", { productId, userId: this.userIdValue }, () => this.refresh())
  }

  restore(event) {
    if (this.inFlight) return
    this.lock(event.currentTarget)

    this.send("restore", {}, () => this.refresh())
  }

  lock(button) {
    this.inFlight = true
    button.disabled = true
    button.classList.add("opacity-50", "pointer-events-none")
  }

  refresh() {
    window.Turbo?.cache?.clear()
    window.location.reload()
  }
}
